/* NANIMERICA card pendant landing: finish toggle (set all) + per-card finish, card flip, quick add (Baseline cart drawer), sticky bar. */
(function () {
  if (window.nrCp) return;
  var SECTIONS = 'cart-items,cart-footer,cart-item-count,cart-live-region';

  var NAMES = { plated: 'Plated', vermeil: 'Vermeil' };
  /* one card: its own finish chips, price, stock, add button label and details link */
  function setCardFinish(c, fin) {
    var id = c.getAttribute('data-' + fin + '-id');
    if (!id) return;
    c.setAttribute('data-fin', fin);
    c.querySelectorAll('[data-nrcp-cfin]').forEach(function (b) {
      b.setAttribute('aria-checked', b.getAttribute('data-nrcp-cfin') === fin ? 'true' : 'false');
    });
    var two = c.classList.contains('has-fin'), price = c.getAttribute('data-' + fin + '-price');
    var btn = c.querySelector('[data-nrcp-add]');
    btn.setAttribute('data-id', id);
    btn.disabled = c.getAttribute('data-' + fin + '-ok') !== '1';
    btn.querySelector('span').textContent = btn.disabled ? (two ? 'Sold out · ' + NAMES[fin] : 'Sold out') : (two ? 'Add · ' + NAMES[fin] + ' · ' + price : 'Add to cart');
    var pr = c.querySelector('[data-nrcp-price]'), was = c.getAttribute('data-' + fin + '-was');
    pr.textContent = '';
    if (was) { var s = document.createElement('s'); s.className = 'nrcp-was'; s.textContent = was; pr.appendChild(s); }
    pr.appendChild(document.createTextNode(price));
    var low = c.querySelector('[data-nrcp-low]');
    if (low) low.hidden = c.getAttribute('data-' + fin + '-low') !== '1';
    var more = c.querySelector('[data-nrcp-more]');
    if (more) more.href = more.getAttribute('data-base') + '?variant=' + id;
  }
  /* the top toggle shows a finish as selected only while every two-finish card is on it */
  function syncAll(root) {
    var fins = [].map.call(root.querySelectorAll('[data-nrcp-card].has-fin'), function (c) { return c.getAttribute('data-fin'); });
    root.querySelectorAll('[data-nrcp-fin]').forEach(function (b) {
      var f = b.getAttribute('data-nrcp-fin');
      b.setAttribute('aria-pressed', fins.length && fins.every(function (x) { return x === f; }) ? 'true' : 'false');
    });
  }
  function setFinish(root, fin) {
    root.querySelectorAll('[data-nrcp-card]').forEach(function (c) { setCardFinish(c, fin); });
    syncAll(root);
  }

  function add(btn) {
    var id = btn.getAttribute('data-id');
    if (!id || btn.disabled || btn.classList.contains('is-busy')) return;
    var label = btn.querySelector('span'), old = label.textContent;
    var err = btn.parentNode.querySelector('.nrcp-err');
    if (err) err.remove();
    btn.classList.add('is-busy'); label.textContent = 'Adding';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: Number(id), quantity: 1, sections: SECTIONS, sections_url: location.pathname })
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        btn.classList.remove('is-busy');
        if (!res.ok) throw new Error(res.j && (res.j.description || res.j.message) || 'Could not add');
        btn.classList.add('is-done'); label.textContent = 'Added';
        setTimeout(function () { btn.classList.remove('is-done'); var c = btn.closest('[data-nrcp-card]'); if (c) setCardFinish(c, c.getAttribute('data-fin')); else label.textContent = old; }, 2200);
        try {
          window.dispatchEvent(new CustomEvent('baseline:cart:afteradditem', { detail: { response: res.j, originalTarget: btn } }));
          if (window.Alpine && Alpine.store('modals')) Alpine.store('modals').open('cart');
        } catch (e) { location.href = '/cart'; }
      })
      .catch(function (e) {
        btn.classList.remove('is-busy'); label.textContent = old;
        var p = document.createElement('p'); p.className = 'nrcp-err'; p.textContent = e.message;
        btn.insertAdjacentElement('afterend', p);
      });
  }

  function sticky() {
    var bar = document.querySelector('[data-nrcp-stick]');
    var pick = document.getElementById('cp-pick');
    var end = document.querySelector('[data-nrcp-end]');
    if (!bar || !pick || !('IntersectionObserver' in window)) return;
    var pastPick = false, endIn = false;
    function upd() { bar.classList.toggle('is-on', pastPick && !endIn); }
    new IntersectionObserver(function (es) {
      es.forEach(function (e) { pastPick = !e.isIntersecting && e.boundingClientRect.top < 0; }); upd();
    }).observe(pick);
    if (end) new IntersectionObserver(function (es) { es.forEach(function (e) { endIn = e.isIntersecting; }); upd(); }).observe(end);
  }

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  function holo(h) {
    if (h.nrHolo) return; h.nrHolo = true;
    var raf = 0, ev = null;
    function paint() {
      raf = 0;
      var r = h.getBoundingClientRect();
      var x = Math.min(1, Math.max(0, (ev.clientX - r.left) / r.width));
      var y = Math.min(1, Math.max(0, (ev.clientY - r.top) / r.height));
      h.style.setProperty('--ry', ((x - 0.5) * 26).toFixed(2) + 'deg');
      h.style.setProperty('--rx', ((0.5 - y) * 22).toFixed(2) + 'deg');
      h.style.setProperty('--mx', (x * 100).toFixed(1) + '%');
      h.style.setProperty('--my', (y * 100).toFixed(1) + '%');
      h.style.setProperty('--o', '1');
    }
    function move(e) {
      if (reduce.matches) return;
      ev = e; h.classList.add('is-live');
      if (!raf) raf = requestAnimationFrame(paint);
    }
    function reset() {
      h.classList.remove('is-live');
      ['--rx', '--ry', '--o'].forEach(function (k) { h.style.removeProperty(k); });
    }
    h.addEventListener('pointermove', move);
    h.addEventListener('pointerdown', move);
    h.addEventListener('pointerleave', reset);
    h.addEventListener('pointercancel', reset);
    h.addEventListener('pointerup', function (e) { if (e.pointerType !== 'mouse') reset(); });
  }

  function init(root) {
    root = root || document;
    root.querySelectorAll('[data-nrcp-holo]').forEach(holo);
    root.querySelectorAll('[data-nrcp-pick]').forEach(function (sec) {
      if (sec.nrReady) return; sec.nrReady = true;
      setFinish(sec, sec.getAttribute('data-default') || 'plated');
    });
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-nrcp-fin]');
    if (t) { setFinish(t.closest('[data-nrcp-pick]'), t.getAttribute('data-nrcp-fin')); return; }
    t = e.target.closest('[data-nrcp-cfin]');
    if (t) { setCardFinish(t.closest('[data-nrcp-card]'), t.getAttribute('data-nrcp-cfin')); var sec = t.closest('[data-nrcp-pick]'); if (sec) syncAll(sec); return; }
    t = e.target.closest('[data-nrcp-flip]');
    if (t) { var c = t.closest('.nrcp-card'); var on = c.classList.toggle('is-back'); t.setAttribute('aria-pressed', on ? 'true' : 'false'); t.querySelector('span').textContent = on ? 'Front' : 'Back'; return; }
    t = e.target.closest('[data-nrcp-add]');
    if (t) { e.preventDefault(); add(t); }
  });

  window.nrCp = { init: init };
  function boot() { init(); sticky(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
